import { IProvinceModel } from './provinceModel';
import { IRoleModel } from './roleModel';
import { IUserModel } from './userModel';
import { IProviderModel } from './providerModel';
import { ILocationModel } from './locationModel';
import { IOrganizationModel } from './organizationModel';
import { IContactFormResultModel } from '../../components/registration/contact/contactFormModel';

export enum EAccountType {
    // eslint-disable-next-line no-unused-vars
    PROFESSIONAL = 1,
    // eslint-disable-next-line no-unused-vars
    ORGANIZATION = 2,
}

export interface IAccountModel {
    id: string;
    firstname: string;
    lastname: string;
    email: string;
    phone: string;
    ext: string;
    type: EAccountType;
    province: number | IProvinceModel;
    locations: ILocationModel[];
    organization: IOrganizationModel;
    user: IUserModel;
    role: number | IRoleModel;
    step: number;
    notify: boolean;
    agreePublish: boolean;
    agreeInformation: boolean;
    registrationId: string;
    referenceNo: string;
    dateLastAction: string;
    reason: string;
    reasonOther: string;
    registrationComplete: boolean;
    provider: IProviderModel[];
}

export const accountModelFromFormData = (
    formData: IContactFormResultModel,
    step: number
): IAccountModel => {
    return {
        firstname: formData.registration_contact_first_name,
        lastname: formData.registration_contact_last_name,
        phone: formData.registration_contact_phone,
        ext: formData.registration_contact_phone_ext,
        email: formData.registration_contact_email,
        step,
        notify: true,
        registrationComplete: false,
        province: Number(formData.registration_contact_provinces),
        agreePublish: true,
        agreeInformation: true,
    } as IAccountModel;
};

export default accountModelFromFormData;
